<template>
  <g>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M11.5342,20.0402c-0.064,0-0.129-0.012-0.192-0.0381
      c-0.255-0.1059-0.376-0.399-0.27-0.6529l0.478-1.155c0.106-0.256,0.401-0.375,0.654-0.2711c0.255,0.1061,0.376,0.399,0.27,0.654
      l-0.478,1.1541C11.9162,19.9241,11.7302,20.0402,11.5342,20.0402 M4.5242,19.7312l0.479-1.155
      c0.105-0.255-0.016-0.5481-0.271-0.6531c-0.253-0.1059-0.547,0.015-0.653,0.27l-0.479,1.1561
      c-0.105,0.255,0.016,0.5471,0.271,0.6529c0.062,0.0261,0.127,0.0381,0.191,0.0381C4.2582,20.0402,4.4442,19.9241,4.5242,19.7312
      M19.4672,19.7312l0.479-1.1541c0.105-0.255-0.016-0.5479-0.271-0.654c-0.253-0.1039-0.547,0.015-0.653,0.2711l-0.478,1.155
      c-0.106,0.2539,0.015,0.5471,0.27,0.6529c0.063,0.0261,0.128,0.0381,0.191,0.0381C19.2012,20.0402,19.3882,19.9241,19.4672,19.7312
      M8.2602,19.7312l0.478-1.1541c0.106-0.255-0.015-0.5479-0.27-0.654c-0.253-0.1039-0.547,0.015-0.653,0.2711l-0.479,1.155
      c-0.105,0.2539,0.016,0.5471,0.271,0.6529c0.062,0.0261,0.127,0.0381,0.191,0.0381C7.9942,20.0402,8.1802,19.9241,8.2602,19.7312
      M15.7322,19.7312l0.478-1.1541c0.106-0.255-0.016-0.5479-0.27-0.654c-0.253-0.1039-0.548,0.015-0.654,0.2711l-0.478,1.155
      c-0.106,0.2539,0.015,0.5471,0.27,0.6529c0.063,0.0261,0.128,0.0381,0.192,0.0381C15.4652,20.0402,15.6522,19.9241,15.7322,19.7312"
      />
    <g>
      <path d="M10.9999,2.9999c2.7609,0,5.1526,1.8724,5.8163,4.5533l0.182,0.7352l0.757,0.024
        c1.8195,0.0577,3.2448,1.5237,3.2448,3.3376c0,1.8472-1.5028,3.35-3.35,3.35h-12.4c-1.2406,0-2.25-1.0094-2.25-2.2501
        c0-0.921,0.5547-1.7391,1.4131-2.0842l0.6992-0.2811L5.0347,9.6351C5.0112,9.4092,4.9999,9.2014,4.9999,9
        C4.9999,5.6916,7.6915,2.9999,10.9999,2.9999 M10.9999,1.9999c-3.866,0-7,3.1331-7,7.0001c0,0.2501,0.015,0.4961,0.04,0.738
        c-1.194,0.48-2.04,1.6451-2.04,3.012c0,1.794,1.4551,3.2501,3.25,3.2501h12.4c2.403,0,4.35-1.9481,4.35-4.35
        c0-2.356-1.875-4.263-4.213-4.3371C17.0319,4.263,14.2839,1.9999,10.9999,1.9999L10.9999,1.9999z"/>
    </g>
  </g>
</template>

<script>
export default {
  name: 'RainLight'
}
</script>